export default "__VITE_ASSET__e28b4d7c__"